import '@babel/polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import { ToastProvider } from 'react-toast-notifications';
import { registerBeaconComponents } from '@trp-beacon-ui-kit/foundation';
import App from './containers/App/App';
import WithUserState, {
    UserContext
} from './components/WithUserState/WithUserState';
import createClient from './graphql/clientSetup';
import { initiateConfig } from './config';

initiateConfig()
    .then(() => {
        const client = createClient();

        registerBeaconComponents('frt');

        const loadApp = ({
            loggedIn,
            userStateLoaded,
            summitTier,
            summitTierLoaded
        }) => (
            <ToastProvider placement="top-center">
                <UserContext.Provider
                    value={{
                        loggedIn,
                        userStateLoaded,
                        summitTier,
                        summitTierLoaded
                    }}
                >
                    <App
                        client={client}
                        loggedIn={loggedIn}
                        userStateLoaded={userStateLoaded}
                        summitTier={summitTier}
                        summitTierLoaded={summitTierLoaded}
                    />
                </UserContext.Provider>
            </ToastProvider>
        );

        ReactDOM.render(
            <WithUserState>{loadApp}</WithUserState>,
            document.getElementById('root')
        );
    })
    .catch();
